import { render, staticRenderFns } from "./NetworkCategoriesPage.vue?vue&type=template&id=466c7825&"
import script from "./NetworkCategoriesPage.vue?vue&type=script&lang=js&"
export * from "./NetworkCategoriesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('466c7825')) {
      api.createRecord('466c7825', component.options)
    } else {
      api.reload('466c7825', component.options)
    }
    module.hot.accept("./NetworkCategoriesPage.vue?vue&type=template&id=466c7825&", function () {
      api.rerender('466c7825', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/NetworkCategoriesPage.vue"
export default component.exports